export const uiElements = {
  results: [
    {
      element_name: 'tooltip_inboxes_inbox_view_copy_url_info_tip',
      content:
        '<p><strong>Inboxes</strong> let you receive files from other people directly in your DISCO.</p>\n<p>Send this URL to anyone who sends you files &mdash; they don&#39;t need to be a DISCO user. </p>\n<p>They&#39;ll be able to upload any kinds of files directly to this inbox, and you&#39;ll be notified when they arrive. Inboxes can save you a heap of time. </p>\n<p><a href="https://support.disco.ac/home/all-about-inboxes" target="_blank">More about inboxes</a></p>\n',
    },
    {
      element_name: 'tooltip_save_playlist_modal_streaming_only',
      content:
        '<p>Checking this box turns off download links for this list.  </p>\n',
    },
    {
      element_name: 'tooltip_settings_themes',
      content:
        '<p>Themes let you customise the design of the playlist pages you send out. </p>\n<p>With themes, you can change the page background and the logo. You can also set a theme to be your default, and go out with each playlist you send. </p>\n<p>Select your themes when saving your playlist. </p>\n<p><a href="https://support.disco.ac/home/playlist-themes" target="_blank">Get more help</a></p>\n',
    },
    {
      element_name: 'tooltip_settings_inboxes',
      content:
        '<p>The inboxes are where you receive files in your DISCO.</p>\n<p>People can send you files in a couple of ways. People who have their own DISCO account can send to you directly, and everyone else can upload to you via your own public upload pages. Grab the public links for your Inboxes here, or from within the inboxes.</p>\n<p>Each DISCO user has a personal inbox, and each business has one. Users on premium plans can also create custom inboxes. </p>\n<p><a href="https://support.disco.ac/home/all-about-inboxes" target="_blank">Get more help</a></p>\n',
    },
    {
      element_name: 'tooltip_edit_multiple_playlist_pane',
      content:
        '<p>If you want to edit or add comments or writers to multiple tracks (or every track) in a playlist at once, click Edit Multiple.</p>\n',
    },
    {
      element_name: 'tooltip_edit_metadata_modal_comments',
      content:
        '<p>DISCO lets you create two kinds of comments for tracks and other files: internal and client comments. </p>\n<p><strong>Internal</strong> comments can just be viewed by you and your team.</p>\n<p><strong>Client</strong> comments appear alongside tracks and other files on pages you send out, so are handy for important info particular to that file (i.e. &#39;one stop&#39;, &#39;kicks at 2.50&#39;)</p>\n<p>Both kinds of comments can be searched in DISCO. </p>\n<p><a href="https://support.disco.ac/home/adding-internal-and-client-notes-to-tracks" target="_blank">Get more help</a></p>\n',
    },
    {
      element_name: 'tooltip_settings_email_groups',
      content:
        '<p>If you regularly send lists to the same groups of people, you can save time and labour by creating email groups.</p>\n<p>You can create groups here or when prompted after you&#39;ve sent to multiple recipients. Add as many people as you like to the groups, and then just type the name of the group in the To: field next time you need to send to them. </p>\n<p><a href="https://support.disco.ac/home/sharing-playlists" target="_blank">Get more help</a></p>\n',
    },
    {
      element_name: 'tooltip_formats_save_playlist_modal',
      content:
        '<p>If you upload audio formats other than mp3, and video formats other than mp4, DISCO will automatically make mp3 and mp4 copies. </p>\n<p>These copies will be sent in your lists by default. You can choose to send the original formats (or both formats together) by clicking this Formats button. </p>\n<p><a href="https://support.disco.ac/home/managing-different-file-formats-for-tracks" target="_blank">Get more help</a></p>\n',
    },
    {
      element_name: 'tooltip_channels_settings',
      content:
        '<p><strong>Channels</strong> are a great way to organise your content in DISCO. They allow you to organise any part of your Catalog, and manage and access it easily.</p>\n<p>To keep things extra organised, you can also create sub-folders within each channel. </p>\n<p>If the Edit Channel or Delete Channel buttons are greyed out, it&#39;s because you&#39;re a member of the channel and not a manager. Contact the manager of the channel in your team for access. </p>\n<p><a href="https://support.disco.ac/home/channels-folders-guide#managing-channel-permissions" target="_blank">Get more help</a>.</p>\n',
    },
    {
      element_name: 'tooltip_allow_bulk_uploads',
      content:
        '<p>Checking this box means third parties can send files to this inbox using the DISCO <a href="https://disco.ac/downloads" target="_blank">bulk uploader</a>.</p>\n<p>Please note this won&#39;t mean receiving unsolicited files from people you don&#39;t know. Third parties will only be able to send to you this way if you give them the details to do so.</p>\n',
    },
    {
      element_name: 'tooltip_inbox_members',
      content: '<p>Members will see this inbox in their DISCO.</p>\n',
    },
    {
      element_name: 'tooltip_inbox_managers',
      content:
        '<p>Managers will be notified by email whenever files are sent to this inbox.</p>\n',
    },
    {
      element_name: 'tooltip_hide_auto_created_album_playlists',
      content:
        '<p>You might see some playlists in DISCO that have no creator listed, and which you didn&#39;t create. These are auto-playlists, playlists created automatically because two or more tracks share artist and album metadata.</p>\n<p>Check this box if you’d like to hide these auto-playlists from your Explorer. (This setting will just affect you, and will take effect next time you click on a library or channel.)</p>\n',
    },
    {
      element_name: 'tooltip_settings_channels_managers',
      content:
        '<p>Only managers can delete channels or change their settings. (Members can still add and remove tracks and playlists.)</p>\n<p><a href="https://support.disco.ac/home/channels-folders-guide#managing-channel-permissions" target="_blank">Get more help</a>. </p>\n',
    },
    {
      element_name: 'tooltip_settings_channels_members',
      content:
        '<p>Members see the channel in their DISCO, and can add music to the channel and remove music from it. But only managers can edit and delete the channel. </p>\n<p><a href="https://support.disco.ac/home/channels-folders-guide#managing-channel-permissions" target="_blank">Get more help</a>. </p>\n',
    },
    {
      element_name: 'tooltip_settings_channels_allow_bulk_uploads',
      content:
        '<p>Checking this box means third parties can send files to this channel using the DISCO bulk uploader.</p>\n<p>This won&#39;t mean receiving unsolicited files from people you don&#39;t know. Third parties will only be able to send to you this way if you give them the details to do so.</p>\n',
    },
    {
      element_name: 'tooltip_channels',
      content:
        '<p><strong>Channels</strong> are a great way to organise your content in DISCO. They allow you to organise any part of your Catalog, and manage and access it easily.</p>\n<p>To keep things extra organised, you can also create sub-folders within each channel. </p>\n<p><a href="https://support.disco.ac/home/channels-folders-guide" target="_blank">Get more help</a>.</p>\n',
    },
    {
      element_name: 'tooltip_settings_column_size',
      content:
        '<p>This setting controls the width of the columns in the Explorer (where your saved playlists live). Use the Larger setting if you have really long titles and a large display.</p>\n<p><a href="https://support.disco.ac/home/explorer-columns" target="_blank">Get more help</a>.</p>\n',
    },
    {
      element_name: 'tooltip_track_merge_modal_header',
      content:
        '<p>The merge function allows you to remove duplicate tracks. </p>\n<p>Just select the duplicate tracks, choose a master track – the copy you&#39;d like to keep – and click Merge. </p>\n<p>The master track will be kept, and the duplicate(s) will be deleted. The master track will then show up in all the playlists the duplicate copies were in. </p>\n<p><a href="https://support.disco.ac/home/merging-tracks" target="_blank">Get more help</a>.\n </p>\n',
    },
    {
      element_name: 'tooltip_track_merge_modal_master_track',
      content:
        '<p>The master track will be the copy that is kept in DISCO after the merge. </p>\n<p><a href="https://support.disco.ac/home/merging-tracks" target="_blank">Get more help</a>. </p>\n',
    },
    {
      element_name: 'tooltip_manage_formats',
      content:
        '<p>Manage formats lets you easily replace track files and add and remove track formats. </p>\n<p>This is handy if you get a new mix or master of a song, or you want to add a wav or aiff to an mp3.  </p>\n<p>Please note this tool only supports audio formats.</p>\n<p><a href="https://support.disco.ac/home/managing-different-file-formats-for-tracks" target="_blank">Get more help</a>. </p>\n',
    },
    {
      element_name: 'tooltip_settings_business_name',
      content:
        '<p>The business name will appear in emails you send out from DISCO.</p>\n',
    },
    {
      element_name: 'tooltip_settings_business_logo',
      content:
        '<p>Your business logo will appear in emails you send out from DISCO and in the top right of your playlists (you can override the logo that appears on playlists with themes if you like).</p>\n<p><a href="https://support.disco.ac/home/playlist-themes" target="_blank">Get more help</a>. </p>\n',
    },
    {
      element_name: 'tooltip_settings_contact_details',
      content:
        '<p>Add a custom contact message here. These messages will appear on all lists you share, and are specific to you (other members in your team can add the same contact details, or have their own).</p>\n',
    },
    {
      element_name: 'tooltip_settings_default_view',
      content:
        '<p>By default, DISCO will show you your Browse view when you login or refresh the page. Choose Starred here if you&#39;d prefer to see your Starred when you log in and refresh.</p>\n',
    },
    {
      element_name: 'tour_breadcrumb_start_hotspot',
      content:
        '<h1>Navigating in DISCO</h1>\n<p>Use the arrow ← → keys to move back and forward through your playlists and tracks.</p>\n',
    },
    {
      element_name: 'tour_inbox_start_modal',
      content:
        '<h1>Save time with Inboxes</h1>\n<p>Inboxes let you receive files from other people directly in your DISCO.</p>\n<p>Copy this URL at the top of the inbox and send to anyone who sends you files — they don&#39;t need to be a DISCO user (but DISCO users <a href="https://support.disco.ac/home/all-about-inboxes#method-2" target="_blank">can send to your inboxes too</a>.</p>\n',
    },
    {
      element_name: 'tour_reports_start_modal',
      content:
        "<h1>Quick insights with Reports</h1>\n<p>DISCO&#39;s Reports feature gives you quick, powerful insights on your work. Generate reports based on specific metadata, channels, or your entire catalog. Easily see what tracks you've pitched, when and to whom.</p>\n",
    },
    {
      element_name: 'tour_notifications_start_hotspot',
      content:
        '<p>Nice one! You just got your first notification. You&#39;ll be notified here when recipients access your files, or when you&#39;re sent files via your inbox. </p>\n<p>You can see complete stats for each playlist by clicking &#39;Playlist stats&#39; from the playlist menu, and overall stats for your DISCO in <a href="/analytics" target="_blank">Analytics</a>.</p>\n',
    },
    {
      element_name: 'tooltip_share_public_url',
      content:
        '<p>This is your main share URL. You can send this to anyone who you want to access your playlist. If you want specific stats for a recipient, though, send the playlist via the Share tab.</p>\n',
    },
    {
      element_name: 'tooltip_share_internal_url',
      content:
        '<p>This URL can be used by your team to access the playlist inside your DISCO. It requires a login to view.</p>\n',
    },
    {
      element_name: 'tooltip_share_direct_url',
      content:
        '<p>This URL will initiate a download of the entire playlist when accessed.</p>\n',
    },
    {
      element_name: 'tooltip_share_assign_tab',
      content:
        '<p>If you want to send your playlist to a contact, but would prefer to send it yourself, rather than use DISCO&#39;s email share function, we&#39;ve got you covered. Just assign a URL to your contact and send it to them. Then, when they access that URL, you can track their activity.</p>\n',
    },
    {
      element_name: 'tooltip_metadata_settings_strip_unknown_meta',
      content:
        '<p>DISCO reads ID3 metadata tags that we don&#39;t display, and writes some of them to files when downloaded. Select &#39;No&#39; if you&#39;d like these fields empty on the tracks in this playlist.</p>\n',
    },
    {
      element_name: 'tooltip_metadata_settings_comments_text',
      content:
        '<p>Enter a custom message here to be added to the Comments metadata field of every track you send. Use this for contact information, or whatever you like :)</p>\n',
    },
    {
      element_name: 'tooltip_metadata_settings_include',
      content:
        '<p>For more on how alias metadata and these settings work, visit our \n<a href="https://support.disco.ac/home/alias-metadata" target="_blank">Support Center</a>.</p>\n',
    },
    {
      element_name: 'tooltip_formats_zip_mode',
      content:
        '<p>When you upload a wav or aiff file, DISCO creates an mp3 copy. By default, the mp3 copy is included in the main playlist zip download your customers access.</p>\n<p>The original formats are still available to download on the pages you share, via individual track download links and in the &#39;More formats and options&#39; view. </p>\n<p>If you’d like the original formats included in the main zip instead of the mp3s, check this toggle. (The mp3s will still be available to download).</p>\n<p>This also applies to video.</p>\n',
    },
    {
      element_name: 'tooltip_formats_share_mode',
      content:
        '<p>When you upload a wav or aiff file, DISCO creates an mp3 copy. By default, the original formats are available for download when you share playlists. </p>\n<p>If you’d like to only have the optimised formats (i.e. mp3) available for this playlist, check this box. This also applies to video.</p>\n',
    },
    {
      element_name: 'tooltip_drm_file',
      content:
        '<p>This file is DRM protected, so unfortunately we can&#39;t play it back.</p>\n',
    },
    {
      element_name: 'tooltip_metadata_modal_pro_number',
      content:
        '<p>This is a general field where you can enter the work number for your collection society (i.e. ISWC or PRO work number). </p>\n<p>Please note that this information is not written to the downloaded metadata of the track.</p>\n',
    },
    {
      element_name: 'tooltip_metadata_modal_isrc',
      content: '<p>TODO: Enter ISRC here</p>',
    },
    {
      element_name: 'tooltip_campaigns_sender_name',
      content:
        '<p>This is the name that will appear as the sender of your emails.</p>\n',
    },
    {
      element_name: 'tooltip_campaigns_sender_email',
      content:
        '<p>This will be displayed as the &#39;from&#39; email on the emails you send. Replies to the emails will also be sent to this address.</p>\n',
    },
    {
      element_name: 'tooltip_campaigns_business_address',
      content:
        '<p>To satisfy anti-SPAM laws, we&#39;re required to list a physical business address on all emails. You can also update this in your Settings.</p>\n',
    },
    {
      element_name: 'tooltip_settings_business_address',
      content:
        '<p>Enter your business address here. This is used for emails you send using our Email Creator.</p>\n',
    },
    {
      element_name: 'tooltip_metadata_modal_strip_unknown_meta',
      content:
        '<p>DISCO reads ID3 metadata tags that we don&#39;t display, and writes some of them to files when downloaded. Check this box if you&#39;d like these fields empty on the tracks in this playlist.</p>\n',
    },
    {
      element_name: 'tooltip_library_settings_describe_supervisors',
      content:
        "<p>Describe your Catalog's sound, and note anything supervisors might find useful, like clearance and territory information</p>\n",
    },
    {
      element_name: 'tooltip_save_playlist_modal_viewable',
      content:
        '<p>Saving a playlist as Viewable only by me will mean only you can see this playlist in your DISCO. Any tracks in the playlist will still be visible to others on your team.</p>\n',
    },
    {
      element_name: 'tooltip_include_stems_modal_viewable',
      content:
        '<p>If checked, nested stems will be accessible from the playlist share page.</p>\n',
    },
    {
      element_name: 'tooltip_include_nested_versions_modal_viewable',
      content:
        '<p>If checked, nested track versions will be accessible from the playlist share page.</p>\n',
    },
    {
      element_name: 'tooltip_what_best_describes_your_role',
      content:
        '<p>The roles you can choose from are dependant on the type of your business. The business can be changed in Business Settings. </p>\n',
    },
  ],
}
